import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.min.css'

import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// Translation provided by Vuetify (javascript)
import zhHans from 'vuetify/lib/locale/zh-Hans'

//import { preset } from 'vue-cli-plugin-vuetify-preset-basil/preset'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { zhHans },
        current: 'zhHans',
    },
    icons: {
        //iconfont: 'mdiSvg'||'md'||'mdi',
        iconfont: 'mdi'||'mdiSvg'||'fa4'||'md', 
    },
})
